import { render, staticRenderFns } from "./page_pagination.vue?vue&type=template&id=28f4ae71&scoped=true"
import script from "./page_pagination.vue?vue&type=script&lang=js"
export * from "./page_pagination.vue?vue&type=script&lang=js"
import style0 from "./page_pagination.vue?vue&type=style&index=0&id=28f4ae71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4ae71",
  null
  
)

export default component.exports